const col = {
    actions: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "130px"},
    actions_medium: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "80px"},
    actions_small: {id: "actions", label: "Acțiuni", numeric: true, sticky: true, width: "50px"},
    test: {id: "test", label: "Test", numeric: true, sortable: true, width: "70px"},
    test_started_at_filter: {id: "test_started_at", label: "Dată", sortable: true, filter: true, filterType: "dateRange", width: "80px"},
    test_started_at: {id: "test_started_at", label: "Dată", sortable: true, width: "80px"},
    user_name: {id: "user_name", label: "Elev", sortable: true, noWrap: true, width: "180px", tooltip: true, tooltipTextLength: 21},
    classroom_name: {id: "classroom_name", label: "Clasă", sortable: true, noWrap: true, width: "60px"},
    test_score_filter: {id: "test_score", label: "Notă/Scor", numeric: true, sortable: true, filter: true, filterType: "number", width: "80px"},
    responses: {id: "responses", label: "Răspunsuri corecte", numeric: true, width: "90px"},
    test_time: {id: "test_time", label: "Timp", noWrap: true, width: "75px"},
    test_time_duration: {id: "test_time", label: "Durată test", noWrap: true, disablePadding: false, width: "100px"},
    owner_name: {id: "owner_name", label: "Profesor", sortable: true, noWrap: true, width: "180px", tooltip: true, tooltipTextLength: 21},
    test_tag: {id: "test_tag", label: "Tag", sortable: true, noWrap: true, width: "80px", tooltip: true, tooltipTextLength: 10},
    test_is_open: {id: "test_is_open", label: "Status", sortable: true,  width: "80px"},
    test_created_at: {id: "test_created_at", label: "Creat", sortable: true, width: "80px"},
    test_expires_at: {id: "test_expires_at", label: "Expiră", sortable: true, width: "80px"},
    test_type: {id: "type", label: "Tip test", hidden: true, filter: true, filterType: "select", hasDefaultValue: true},
    school_year: {id: "school_year", label: "An scolar", hidden: true, filter: true, filterType: "schoolYear"},
    test_type_subject_filter: {id: "test_type", label: "Disciplină", sortable: true, noWrap: true, filter: true, filterType: "select", width: "130px", tooltip: true, tooltipTextLength: 21},
    test_type_tip: {id: "test_type", label: "Tip test", noWrap: true, width: "150px"},
    test_grade: {id: "test_grade", label: "Clasă test", width: "40px"},
    test_grade_bac_filter: {id: "test_grade", label: "Disciplină", sortable: true, noWrap: true, filter: true, filterType: "select", width: "200px"},
    test_grade_sortable: {id: "test_grade", label: "Disciplină", sortable: true, width: "200px"},
    test_grade_ev: {id: "test_grade", label: "Disciplină", sortable: false, width: "200px"},
}

// Active tests - SCHOOL
const ACTIVE_TESTS_PRINCIPAL = [
    col.test_type_subject_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ACTIVE_TESTS_TEACHER = [
    col.test_type_subject_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.test_tag, col.test, col.actions,
];

const ACTIVE_TESTS_STUDENT = [
    col.test_type_subject_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.classroom_name, col.test_is_open, col.owner_name, col.test, col.actions_small,
];

// History tests - SCHOOL
const HISTORY_TESTS_PRINCIPAL = [
    col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions
];

const HISTORY_TESTS_CLASSROOM_PAGE = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions
];

const HISTORY_TESTS_STUDENT_PAGE = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_TEACHER = [
    col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions
];

const HISTORY_TESTS_STUDENT = [
    col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Archived tests - SCHOOL

const ARCHIVED_TESTS_PRINCIPAL = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions
];

const ARCHIVED_TESTS_TEACHER = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_STUDENT = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Active tests - BAC
const ACTIVE_TESTS_BAC_PRINCIPAL = [
    col.test_grade_bac_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ACTIVE_TESTS_BAC_TEACHER = [
    col.test_grade_bac_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.test_tag, col.test, col.actions,
];

const ACTIVE_TESTS_BAC_STUDENT = [
    col.test_grade_bac_filter, col.test_created_at, col.test_expires_at, col.test_time_duration, col.classroom_name, col.test_is_open, col.owner_name, col.test, col.actions_small,
];

// History tests - BAC
const HISTORY_TESTS_BAC_PRINCIPAL = [
    col.test_grade_bac_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_CLASSROOM_PAGE = [
    col.test_type, col.test_grade_bac_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_STUDENT_PAGE = [
    col.test_type, col.test_grade_bac_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time,  col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_TEACHER = [
    col.test_grade_bac_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_grade_bac_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_grade_bac_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_BAC_STUDENT = [
    col.test_grade_bac_filter, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Archived tests - BAC

const ARCHIVED_TESTS_BAC_PRINCIPAL = [
    col.school_year, col.test_grade_bac_filter, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_BAC_TEACHER = [
    col.school_year, col.test_grade_bac_filter, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_BAC_STUDENT = [
    col.school_year, col.test_grade_bac_filter, col.test_started_at, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// History tests - TRAINING
const HISTORY_TESTS_TRAINING_PRINCIPAL = [
    col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_CLASSROOM_PAGE = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_STUDENT_PAGE = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_TEACHER = [
    col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.user_name, col.classroom_name, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_TRAINING_STUDENT = [
    col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test, col.actions_small,
];

// Archived tests - TRAINING

const ARCHIVED_TESTS_TRAINING_PRINCIPAL = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.user_name, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ARCHIVED_TESTS_TRAINING_TEACHER = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.user_name, col.classroom_name, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const ARCHIVED_TESTS_TRAINING_STUDENT = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test, col.actions_small,
];

// Active tests - LITERACY
const ACTIVE_TESTS_LITERACY_PRINCIPAL = [
    col.test_grade, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ACTIVE_TESTS_LITERACY_TEACHER = [
    col.test_grade, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.test_tag, col.test, col.actions,
];

const ACTIVE_TESTS_LITERACY_STUDENT = [
    col.test_grade, col.test_created_at, col.test_expires_at, col.test_time_duration, col.classroom_name, col.test_is_open, col.owner_name, col.test, col.actions,
];

// History tests - LITERACY
const HISTORY_TESTS_LITERACY_PRINCIPAL = [
    col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_CLASSROOM_PAGE = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_STUDENT_PAGE = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_TEACHER = [
    col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_LITERACY_STUDENT = [
    col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Archived tests - LITERACY

const ARCHIVED_TESTS_LITERACY_PRINCIPAL = [
    col.school_year, col.test_grade, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_LITERACY_TEACHER = [
    col.school_year, col.test_grade, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_LITERACY_STUDENT = [
    col.school_year, col.test_grade, col.test_started_at, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Active tests - NUMERIC LITERACY
const ACTIVE_TESTS_NUMERIC_LITERACY_PRINCIPAL = [
    col.test_type_tip, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ACTIVE_TESTS_NUMERIC_LITERACY_TEACHER = [
    col.test_type_tip, col.test_created_at, col.test_expires_at, col.test_time_duration, col.user_name, col.classroom_name, col.test_is_open, col.test_tag, col.test, col.actions,
];

const ACTIVE_TESTS_NUMERIC_LITERACY_STUDENT = [
    col.test_type_tip, col.test_created_at, col.test_expires_at, col.test_time_duration, col.classroom_name, col.test_is_open, col.owner_name, col.test, col.actions,
];

// History tests - NUMERIC LITERACY
const HISTORY_TESTS_NUMERIC_LITERACY_PRINCIPAL = [
    col.test_type_tip, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_CLASSROOM_PAGE = [
    col.test_type, col.test_type_tip, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_STUDENT_PAGE = [
    col.test_type, col.test_type_tip, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_TEACHER = [
    col.test_type_tip, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_type_tip, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_type_tip, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const HISTORY_TESTS_NUMERIC_LITERACY_STUDENT = [
    col.test_type_tip, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// Archived tests - NUMERIC LITERACY

const ARCHIVED_TESTS_NUMERIC_LITERACY_PRINCIPAL = [
    col.school_year, col.test_type_tip, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_NUMERIC_LITERACY_TEACHER = [
    col.school_year, col.test_type_tip, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions,
];

const ARCHIVED_TESTS_NUMERIC_LITERACY_STUDENT = [
    col.school_year, col.test_type_tip, col.test_started_at, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_medium,
];

// History tests - SCIENTIFIC LITERACY
const HISTORY_TESTS_SCIENTIFIC_LITERACY_PRINCIPAL = [
    col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_CLASSROOM_PAGE = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT_PAGE = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_TEACHER = [
    col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_CLASSROOM_PAGE_TEACHER = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT_PAGE_TEACHER = [
    col.test_type, col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT = [
    col.test_grade, col.test_started_at_filter, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_small,
];

// Archived tests - SCIENTIFIC LITERACY

const ARCHIVED_TESTS_SCIENTIFIC_LITERACY_PRINCIPAL = [
    col.school_year, col.test_grade, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test_tag, col.test, col.actions_medium,
];

const ARCHIVED_TESTS_SCIENTIFIC_LITERACY_TEACHER = [
    col.school_year, col.test_grade, col.test_started_at, col.user_name, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.test_tag, col.test, col.actions_medium,
];

const ARCHIVED_TESTS_SCIENTIFIC_LITERACY_STUDENT = [
    col.school_year, col.test_grade, col.test_started_at, col.classroom_name, col.test_score_filter, col.responses, col.test_time, col.owner_name, col.test, col.actions_small,
];

// History tests - CUSTOM
const HISTORY_TESTS_CUSTOM_STUDENT = [
    col.test_type_subject_filter, col.test_started_at_filter, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test,
];

// Archived tests - CUSTOM

const ARCHIVED_TESTS_CUSTOM_STUDENT = [
    col.school_year, col.test_type_subject_filter, col.test_started_at, col.classroom_name, col.responses, col.test_time, col.owner_name, col.test,
];

function getTestTypeGroup(testType: string, position: string, isActive: boolean): string {
    if (["literacy", "digitalLiteracy"].includes(testType)) return "literacy";
    if (testType === "scientificLiteracy") return isActive ? "literacy" : "scientificLiteracy";
    if (testType === "numericLiteracy") return "numericLiteracy";
    if (["bac", "evaluate"].includes(testType)) return "bac";

    if (!isActive) {
        if (position !== "student" && ["training", "customTest"].includes(testType)) return "training";
        if (position === "student" && testType === "training") return "training";
        if (position === "student" && testType === "customTest") return "customTest";
    }

    return "default";
}

type ColumnMap = Record<string, any[] | undefined>;

const ACTIVE_COLUMNS_MAP: ColumnMap = {
    // ── principal ──────────────────────────────────────────
    "principal_default":            ACTIVE_TESTS_PRINCIPAL,
    "principal_bac":                ACTIVE_TESTS_BAC_PRINCIPAL,
    "principal_literacy":           ACTIVE_TESTS_LITERACY_PRINCIPAL,
    "principal_numericLiteracy":    ACTIVE_TESTS_NUMERIC_LITERACY_PRINCIPAL,

    // ── teacher ─────────────────────────────────────────────
    "teacher_default":              ACTIVE_TESTS_TEACHER,
    "teacher_bac":                  ACTIVE_TESTS_BAC_TEACHER,
    "teacher_literacy":             ACTIVE_TESTS_LITERACY_TEACHER,
    "teacher_numericLiteracy":      ACTIVE_TESTS_NUMERIC_LITERACY_TEACHER,

    // ── student ─────────────────────────────────────────────
    "student_default":              ACTIVE_TESTS_STUDENT,
    "student_bac":                  ACTIVE_TESTS_BAC_STUDENT,
    "student_literacy":             ACTIVE_TESTS_LITERACY_STUDENT,
    "student_numericLiteracy":      ACTIVE_TESTS_NUMERIC_LITERACY_STUDENT,
}

const HISTORY_COLUMNS_MAP: ColumnMap = {
    // ── principal, NOT student page ──────────────────────────────────────────
    "principal_self_literacy":              HISTORY_TESTS_LITERACY_PRINCIPAL,
    "principal_self_numericLiteracy":       HISTORY_TESTS_NUMERIC_LITERACY_PRINCIPAL,
    "principal_self_scientificLiteracy":    HISTORY_TESTS_SCIENTIFIC_LITERACY_PRINCIPAL,
    "principal_self_training":              HISTORY_TESTS_TRAINING_PRINCIPAL,
    "principal_self_bac":                   HISTORY_TESTS_BAC_PRINCIPAL,
    "principal_self_default":               HISTORY_TESTS_PRINCIPAL,

    // ── teacher, NOT student page ─────────────────────────────────────────────
    "teacher_self_literacy":            HISTORY_TESTS_LITERACY_TEACHER,
    "teacher_self_numericLiteracy":     HISTORY_TESTS_NUMERIC_LITERACY_TEACHER,
    "teacher_self_scientificLiteracy":  HISTORY_TESTS_SCIENTIFIC_LITERACY_TEACHER,
    "teacher_self_training":            HISTORY_TESTS_TRAINING_TEACHER,
    "teacher_self_bac":                 HISTORY_TESTS_BAC_TEACHER,
    "teacher_self_default":             HISTORY_TESTS_TEACHER,

    // ── student, NOT student page ─────────────────────────────────────────────
    "student_self_literacy":            HISTORY_TESTS_LITERACY_STUDENT,
    "student_self_numericLiteracy":     HISTORY_TESTS_NUMERIC_LITERACY_STUDENT,
    "student_self_scientificLiteracy":  HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT,
    "student_self_training":            HISTORY_TESTS_TRAINING_STUDENT,
    "student_self_customTest":          HISTORY_TESTS_CUSTOM_STUDENT,
    "student_self_bac":                 HISTORY_TESTS_BAC_STUDENT,
    "student_self_default":             HISTORY_TESTS_STUDENT,

    // ── student page, principal ───────────────────────────────────────────────
    "principal_studentPage_literacy":           HISTORY_TESTS_LITERACY_STUDENT_PAGE,
    "principal_studentPage_numericLiteracy":    HISTORY_TESTS_NUMERIC_LITERACY_STUDENT_PAGE,
    "principal_studentPage_scientificLiteracy": HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT_PAGE,
    "principal_studentPage_training":           HISTORY_TESTS_TRAINING_STUDENT_PAGE,
    "principal_studentPage_bac":                HISTORY_TESTS_BAC_STUDENT_PAGE,
    "principal_studentPage_default":            HISTORY_TESTS_STUDENT_PAGE,

    // ── student page, teacher ─────────────────────────────────────────────────
    "teacher_studentPage_literacy":             HISTORY_TESTS_LITERACY_STUDENT_PAGE_TEACHER,
    "teacher_studentPage_numericLiteracy":      HISTORY_TESTS_NUMERIC_LITERACY_STUDENT_PAGE_TEACHER,
    "teacher_studentPage_scientificLiteracy":   HISTORY_TESTS_SCIENTIFIC_LITERACY_STUDENT_PAGE_TEACHER,
    "teacher_studentPage_training":             HISTORY_TESTS_TRAINING_STUDENT_PAGE_TEACHER,
    "teacher_studentPage_bac":                  HISTORY_TESTS_BAC_STUDENT_PAGE_TEACHER,
    "teacher_studentPage_default":              HISTORY_TESTS_STUDENT_PAGE_TEACHER,

    // ── classroom page, principal ─────────────────────────────────────────────────
    "principal_classroomPage_literacy":             HISTORY_TESTS_LITERACY_CLASSROOM_PAGE,
    "principal_classroomPage_numericLiteracy":      HISTORY_TESTS_NUMERIC_LITERACY_CLASSROOM_PAGE,
    "principal_classroomPage_scientificLiteracy":   HISTORY_TESTS_SCIENTIFIC_LITERACY_CLASSROOM_PAGE,
    "principal_classroomPage_training":             HISTORY_TESTS_TRAINING_CLASSROOM_PAGE,
    "principal_classroomPage_bac":                  HISTORY_TESTS_BAC_CLASSROOM_PAGE,
    "principal_classroomPage_default":              HISTORY_TESTS_CLASSROOM_PAGE,

    // ── classroom page, teacher ─────────────────────────────────────────────────
    "teacher_classroomPage_literacy":           HISTORY_TESTS_LITERACY_CLASSROOM_PAGE_TEACHER,
    "teacher_classroomPage_numericLiteracy":    HISTORY_TESTS_NUMERIC_LITERACY_CLASSROOM_PAGE_TEACHER,
    "teacher_classroomPage_scientificLiteracy": HISTORY_TESTS_SCIENTIFIC_LITERACY_CLASSROOM_PAGE_TEACHER,
    "teacher_classroomPage_training":           HISTORY_TESTS_TRAINING_CLASSROOM_PAGE_TEACHER,
    "teacher_classroomPage_bac":                HISTORY_TESTS_BAC_CLASSROOM_PAGE_TEACHER,
    "teacher_classroomPage_default":            HISTORY_TESTS_CLASSROOM_PAGE_TEACHER,
};

const ARCHIVED_COLUMNS_MAP: ColumnMap = {
    // ── principal ──────────────────────────────────────────
    "principal_literacy":              ARCHIVED_TESTS_LITERACY_PRINCIPAL,
    "principal_numericLiteracy":       ARCHIVED_TESTS_NUMERIC_LITERACY_PRINCIPAL,
    "principal_scientificLiteracy":    ARCHIVED_TESTS_SCIENTIFIC_LITERACY_PRINCIPAL,
    "principal_training":              ARCHIVED_TESTS_TRAINING_PRINCIPAL,
    "principal_bac":                   ARCHIVED_TESTS_BAC_PRINCIPAL,
    "principal_default":               ARCHIVED_TESTS_PRINCIPAL,

    // ── teacher ─────────────────────────────────────────────
    "teacher_literacy":            ARCHIVED_TESTS_LITERACY_TEACHER,
    "teacher_numericLiteracy":     ARCHIVED_TESTS_NUMERIC_LITERACY_TEACHER,
    "teacher_scientificLiteracy":  ARCHIVED_TESTS_SCIENTIFIC_LITERACY_TEACHER,
    "teacher_training":            ARCHIVED_TESTS_TRAINING_TEACHER,
    "teacher_bac":                 ARCHIVED_TESTS_BAC_TEACHER,
    "teacher_default":             ARCHIVED_TESTS_TEACHER,

    // ── student ─────────────────────────────────────────────
    "student_literacy":            ARCHIVED_TESTS_LITERACY_STUDENT,
    "student_numericLiteracy":     ARCHIVED_TESTS_NUMERIC_LITERACY_STUDENT,
    "student_scientificLiteracy":  ARCHIVED_TESTS_SCIENTIFIC_LITERACY_STUDENT,
    "student_training":            ARCHIVED_TESTS_TRAINING_STUDENT,
    "student_customTest":          ARCHIVED_TESTS_CUSTOM_STUDENT,
    "student_bac":                 ARCHIVED_TESTS_BAC_STUDENT,
    "student_default":             ARCHIVED_TESTS_STUDENT,
}

export function getActiveTableColumns(
    position: string,
    testType: string,
): any[] {
    const typeGroup = getTestTypeGroup(testType, position, true);
    const key = `${position}_${typeGroup}`;

    return ACTIVE_COLUMNS_MAP[key] ?? [];
}

export function getHistoryTableColumns(
    position: string,
    pageType: string | undefined,
    testType: string,
): any[] {
    const context = pageType === "student" ? "studentPage" : pageType === "classroom" ? "classroomPage" : "self";
    const typeGroup = getTestTypeGroup(testType, position, false);
    const key = `${position}_${context}_${typeGroup}`;

    return HISTORY_COLUMNS_MAP[key] ?? [];
}

export function getArchivedTableColumns(
    position: string,
    testType: string,
): any[] {
    const typeGroup = getTestTypeGroup(testType, position, false);
    const key = `${position}_${typeGroup}`;

    return ARCHIVED_COLUMNS_MAP[key] ?? [];
}